<template>
  <Layout title="Storyboard Scenes" description="Storyboard scenes are individual visual frames or panels that outline key moments of a story, showing the sequence of events, characters, and actions, usually with short descriptions or notes to guide production.">
    <!-- <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center gap-3">
        <router-link to="/crm" class="text-muted text-decoration-none small">&larr; Back to Clients</router-link>
        <div>
          <h4 class="mb-0 fw-bold">Storyboard Scenes</h4>
      <div class="text-muted small">{{ customer.industry }}</div
        </div>
      </div>
    </div> -->

    <div>
      <!-- Header -->
      <div class="d-flex flex-wrap justify-content-end align-items-start gap-2 mb-3">

  <!-- Add Scene (with credit note) -->
  <div class="d-flex flex-column align-items-center">
    <button class="btn btn-sm text-white border"
            @click="addScene"
            style="background: linear-gradient(to right, #d946ef, #8b5cf6)">
      Add Scene
    </button>
    <small class="text-muted mt-1">🎬 Costs 1 credit</small>
  </div>

  <!-- Save Order -->
  <button class="btn btn-sm text-white border"
          style="background: linear-gradient(to right, #d946ef, #8b5cf6)"
          :disabled="!isDirty || saving"
          @click="saveOrderNow">
    {{ saving ? 'Saving…' : 'Save Order' }}
  </button>

  <!-- Reset -->
  <button class="btn btn-sm text-white border"
          style="background: linear-gradient(to right, #d946ef, #8b5cf6)"
          :disabled="!isDirty || saving"
          @click="revertOrder">
    Reset
  </button>

  <!-- Copy URL -->
  <button class="btn btn-sm text-white border"
          style="background: linear-gradient(to right, #d946ef, #8b5cf6)"
          @click="copyURL">
    Copy URL
  </button>
</div>



      <!-- Draggable grid -->
      <div class="scenes-scroll">
        <draggable
          v-model="scenes"
          item-key="id"
          class="row g-3"
          handle=".drag-handle"
          @end="onReorder"
        >
          <template #item="{ element: scene }">
            <div class="col-md-4 col-sm-6">
              <div class="card h-100 border rounded-4 p-3">

                <!-- Top Row: Scene badge + icons (with drag handle) -->
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <span class="badge rounded-pill text-dark border">
                    Scene {{ scene.number }}
                  </span>
                  <div class="d-flex align-items-center gap-2">
                    <GripVertical class="drag-handle text-muted" :size="18" style="cursor: grab;" />
                    <Download class="me-1" :size="18" style="cursor:pointer" @click="downloadVideo(scene.videoUrl, 'scene.mp4')" />
                    <Trash2 class="me-1" :size="18" style="cursor:pointer" @click="deleteScene(scene)" />
                  </div>
                </div>

                <!-- Title -->
                <h6 class="fw-semibold">{{ scene.title }}</h6>

                <!-- Image / Emoji -->
                <div 
                  class="d-flex justify-content-center align-items-center bg-light rounded-3 my-3" 
                  style="height:300px;"
                >
                  <video
                    :src="scene.videoUrl"
                    style="height: 100%; width: 100%; object-fit: cover; border-radius: .5rem;"
                    controls
                    playsinline
                  ></video>
                </div>


                <!-- Description -->
                <p class="small text-muted">{{ scene.description }}</p>

                <!-- Duration -->
                <div class="d-flex justify-content-end">
                  <span class="badge rounded-pill bg-info text-white">
                    {{ scene.duration }}s
                  </span>
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- Add Scene Modal -->
      <div
        v-if="showAddSceneModal"
        class="modal fade show"
        tabindex="-1"
        style="display:block; background: rgba(0,0,0,.4);"
        role="dialog"
        aria-modal="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content p-3">
            <div class="modal-header">
              <h5 class="modal-title">Add New Scene</h5>
              <button type="button" class="btn-close" @click="closeSceneModal"></button>
              
            </div>

            <div class="modal-body">
              <!-- Title -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Title</label>
                <input v-model.trim="newScene.title" type="text" class="form-control" placeholder="e.g. Hook - Problem Statement" />
              </div>

              <!-- Description -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Description</label>
                <textarea v-model.trim="newScene.description" class="form-control" rows="3" placeholder="Short description..."></textarea>
              </div>
              <!-- Description -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Duration</label>
                <input v-model.trim="newScene.duration" type="number" class="form-control" placeholder="3s" />
              </div>

              <!-- Image (optional) -->
              <div class="mb-3">
                <label class="form-label fw-semibold">Image (optional)</label>
                <input type="file" class="form-control" accept="image/*" @change="onSceneImageChange" />
                <div v-if="newScene.imagePreview" class="mt-2">
                  <img :src="newScene.imagePreview" class="img-fluid rounded border" alt="preview" />
                  <button class="btn btn-sm btn-outline-secondary mt-2" @click="removeSceneImage">Remove image</button>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary" @click="closeSceneModal" :disabled="addingScene">Cancel</button>
              <button class="btn btn-primary" @click="createScene" :disabled="addingScene || !newScene.title">
                <span v-if="addingScene" class="spinner-border spinner-border-sm me-2"></span>
                Add Scene
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
    
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import draggable from 'vuedraggable'
import { GripVertical, Trash2,Download } from 'lucide-vue-next'
import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import { useToast } from 'vue-toastification'

export default {
  name: 'Storyboard',
  components: { Layout, draggable, GripVertical, Trash2,Download },
  data() {
    return {
      // scenes: [
      //   { id: 1, number: 1, title: 'Hook - Problem Statement', videoUrl:"https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/6026114_Person_People_3840x2160.mp4?alt=media&token=29bccc80-81ef-4fc3-83e3-bee8d133fd75", description: 'Customer frustrated with slow support response times', duration: 3 },
      //   { id: 2, number: 2, title: 'Solution Introduction', videoUrl:"https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/14163920_1920_1080_30fps.mp4?alt=media&token=54c66873-5b67-4fb3-920e-6cb817821bed", description: "Introduce TechFlow's AI-powered instant support", duration: 4 },
      //   { id: 3, number: 3, title: 'Demo - Real-time Response', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/14163920_1920_1080_30fps.mp4?alt=media&token=54c66873-5b67-4fb3-920e-6cb817821bed", description: 'Show AI responding to customer query in real-time', duration: 6 },
      //   { id: 4, number: 4, title: 'Customer Satisfaction', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/13948810_3840_2160_50fps.mp4?alt=media&token=ef01ceaa-50eb-4c48-8fab-4b3d7357fb0d", description: 'Happy customer receiving instant, accurate help', duration: 3 },
      //   { id: 5, number: 5, title: 'Call to Action', videoUrl: "https://firebasestorage.googleapis.com/v0/b/werkmarketingtool.firebasestorage.app/o/12472746_1920_1080_24fps.mp4?alt=media&token=5cbac7d4-eb1b-43a4-be81-470396e30f41", description: "Learn more about TechFlow's AI solutions", duration: 2 }
      // ],
      ideaId:"",
      scenes: [],
      lastSavedOrder: [],   // snapshot of ids
      saving: false,
      addingScene: false,
      newScene: {
        title: '',
        description: '',
        imageFile: null,
        imagePreview: null,
        imageUrl: '',
        duration:''
      },
      showAddSceneModal:false,
      // apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
    }
  },
  setup() {
    const toast = useToast()

    return {
      toast
    }
  },
    async mounted(){
      this.userID = this.$store.getters.getUserId;
      this.ideaId = this.$route.params.id
      await this.checkAuthState();
      await this.refreshScenes()
  },
  methods: {
    async downloadVideo(url,filename = 'video.mp4' ) {

        // Always encode the Firebase/GCS URL properly
        const apiUrl =
          `${this.apiURL}/download/video?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(filename)}&t=${Date.now()}`;

        // Navigate to API — browser will show Save dialog
        window.location.assign(apiUrl);
        // If you prefer a new tab: window.open(apiUrl, '_blank', 'noopener');
    },
    copyURL() {
      const url = "https://genstoryflow.web.app/StoryboardClient/"+this.ideaId // or put your own custom URL
      navigator.clipboard.writeText(url)
        .then(() => {
          this.toast.success("URL copied to clipboard!")
        })
        .catch(() => {
          this.toast.error("Failed to copy");
        });
    },
     async saveOrderNow() {
      try {
        this.saving = true
        const payload = {
          ideaID: this.ideaId,  // optional server-side validation
          order: this.scenes.map((s, i) => ({ id: s.id, pos: i + 1 }))
        }
        await axios.put(`${this.apiURL}/reorderStoryboards`, payload, {
          headers: await this.getAuthHeader()
        })

        // success → tidy + snapshot
        this.scenes.forEach((s, i) => (s.number = i + 1))
        this.lastSavedOrder = this.scenes.map(s => s.id)
        this.toast.success("Order Save")
      } catch (e) {
        console.error(e)
        // optional: toast error
      } finally {
        this.saving = false
      }
    },
    async refreshScenes() {
      if (!this.ideaId) return
      this.isLoading = true
      this.loadError = ''
      try {
        const res = await axios.get(`${this.apiURL}/getStoryboards`, {
          params: { ideaID: this.ideaId },                 // << note: ideaID (your backend)
          headers: await this.getAuthHeader()
        })

        const rows = (res && res.data && Array.isArray(res.data.data))
                      ? res.data.data
                      : []

        // Already ordered by SceneNumber from backend, but we sanitize anyway
        rows.sort((a, b) => {
        const aNum = (a && a.SceneNumber != null) ? a.SceneNumber : 0
        const bNum = (b && b.SceneNumber != null) ? b.SceneNumber : 0
        return aNum - bNum
      })

        this.scenes = rows.map((d, i) => ({
          id: d.id,
          number: (d.SceneNumber != null ? d.SceneNumber : (i + 1)),
          title: d.Title || `Scene ${(d.SceneNumber != null ? d.SceneNumber : (i + 1))}`,  // fallback if no Title
          description: d.Description || '',
          imageUrl: d.ImageUrl || '',   // backend can add later
          videoUrl: d.VideoUrl || '',
          duration: (d.Duration != null ? d.Duration : 3)
        }))

        // tidy numbers + snapshot
        this.scenes.forEach((s, i) => (s.number = i + 1))
        this.lastSavedOrder = this.scenes.map(s => s.id)
      } catch (err) {
        console.error(err)
        this.loadError = 'Cannot load storyboards, try again later.'
      } finally {
        this.isLoading = false
      }
    },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');

      const token = await user.getIdToken(); // 🔐 always fresh
      return {
        Authorization: token
      };
    },
    async checkAuthState() {
            const auth = getAuth();
            return new Promise((resolve, reject) => {
            onAuthStateChanged(auth, async (user) => {
                if (user) {
                try {
                    const idToken = await user.getIdToken();
                    this.token = idToken;
                    resolve(); // 🔥 Only resolve when token is ready
                } catch (error) {
                    reject(error);
                }
                } else {
                router.push("/");
                reject(new Error("No user logged in"));
                }
            });
            });
    },
    async deleteScene(scene) {
      // if (!confirm(`Confirm delete scene "${scene.title || scene.number}"?`)) return
       try {
          this.deletingId = scene.id;
          const headers = await this.getAuthHeader();

          // 1) delete
          await axios.delete(`${this.apiURL}/deleteStoryboard/${scene.id}`, { headers });

          // 2) pull fresh (now got gaps e.g. 1,2,4,5)
          await this.refreshScenes();

          // 3) compress to 1..n via batch reorder (always send; cheap & consistent)
          this.savingOrder = true;
          const payload = {
            ideaID: this.ideaId,
            order: this.scenes.map((s, i) => ({ id: s.id, pos: i + 1 }))
          };
          await axios.put(`${this.apiURL}/reorderStoryboards`, payload, { headers });

          // 4) pull again to lock UI to server truth
          await this.refreshScenes();

          // 5) reset dirty snapshot
          this.lastSavedOrder = this.scenes.map(s => s.id);

          this.toast.success('Deleted & reordered');
        } catch (e) {
          console.error(e);
          this.toast.error('Delete failed, try again.');
          // Optional: fall back to client-only renumber to avoid visual gaps
          this.scenes.forEach((s, i) => (s.number = i + 1));
        } finally {
          this.deletingId = null;
          this.savingOrder = false;
        }
    },
    onReorder() {
      // renumber after drag
      this.scenes.forEach((s, i) => (s.number = i + 1))
      // TODO: call API to persist order if you want
      // await axios.post(`${this.apiURL}/reorderScenes`, { order: this.scenes.map(s => s.id) }, { headers: await this.getAuthHeader() })
    },
    revertOrder() {
      // put scenes back to last saved order
      console.log("HERE")
      const indexOfId = new Map(this.lastSavedOrder.map((id, idx) => [id, idx]));
      this.scenes.sort((a, b) => indexOfId.get(a.id) - indexOfId.get(b.id));
      this.scenes.forEach((s, i) => (s.number = i + 1));
    },
    addScene() {
      this.newScene = { title: '', description: '', imageFile: null, imagePreview: null, imageBase64: '' }
      this.showAddSceneModal = true
    },
    closeSceneModal() {
      if (this.newScene.imagePreview) URL.revokeObjectURL(this.newScene.imagePreview)
      this.showAddSceneModal = false
    },
    onSceneImageChange(e) {
      const f = e.target.files[0];
      if (!f) return;
      if (!/^image\/(jpeg|png)$/i.test(f.type)) {
        this.toast.error("Only JPG/PNG, bro.");
        e.target.value = "";
        return;
      }
      if (this.newScene.imagePreview) URL.revokeObjectURL(this.newScene.imagePreview);
      this.newScene.imageFile = f;
      this.newScene.imagePreview = URL.createObjectURL(f); // you missed this earlier
      e.target.value = ""; // allow reselect
    },
    removeSceneImage() {
      if (this.newScene.imagePreview) URL.revokeObjectURL(this.newScene.imagePreview)
      this.newScene.imageFile = null
      this.newScene.imagePreview = null
      this.newScene.imageBase64 = ''
    },
      async createScene() {
        try {
          this.addingScene = true;
          const sceneNumber = this.scenes.length + 1;

          const fd = new FormData();
          fd.append("SceneNumber", String(sceneNumber));
          fd.append("userID", String(this.userID));
          fd.append("Description", this.newScene.description || "");
          fd.append(
            "Duration",
            String((this.newScene.duration != null) ? this.newScene.duration : 3)
          );
          fd.append("IdeaID", this.ideaId);
          fd.append("Title", (this.newScene.title || "").trim());
          if (this.newScene.imageFile) {
            fd.append("image", this.newScene.imageFile, this.newScene.imageFile.name);
          }

          const headers = await this.getAuthHeader(); // MUST be only Authorization
          // very important: ensure no 'Content-Type': 'application/json'
          if (headers['Content-Type']) delete headers['Content-Type'];

          const res = await axios.post(`${this.apiURL}/createStoryboard`, fd, { headers });
          if(res.data.creditSufficient){
            this.closeSceneModal();
            this.refreshScenes();
            this.toast.success("Scene Created");
          }else{
            this.toast.error("Insufficient Credit");

          }
        } catch (e) {
          console.error(e);
          this.toast.error('Add scene failed, try again.');
        } finally {
          this.addingScene = false;
          this.newScene.imageFile = null;
        }
      }



    
  },
  computed: {
    // dirty if ids (order/length) changed
    isDirty() {
      const a = this.lastSavedOrder;
      const b = this.scenes.map(s => s.id);
      if (a.length !== b.length) return true;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return true;
      return false;
    }
  },
}
</script>

<style scoped>
.card { transition: box-shadow 0.2s; }
.card:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.08); }
/* optional nicer grabbing cursor while dragging */
.drag-handle:active { cursor: grabbing !important; }.scenes-scroll {
  max-height: 70vh; /* adjust so it fits nicely in your layout */
  overflow-y: auto;
  padding-right: 8px; /* for scrollbar spacing */
}

/* Optional: nicer thin scrollbar */
.scenes-scroll::-webkit-scrollbar {
  width: 6px;
}
.scenes-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

</style>
